import {
  Compliance,
  ComplianceProps,
} from "~/pages/compliance/EntryPage/Compliance";

const ComplianceEntryPage = ({ space }: ComplianceProps) => {
  return <Compliance space={space} />;
};

export default ComplianceEntryPage;
